import type { FC } from 'react';
import type { DashboardRegistry } from '../consts/dashboard-registry';

export const resolveDashboardLoader = (
  roles: ReadonlyArray<string>,
  registry: DashboardRegistry,
): { load: () => Promise<{ default: FC }> } | null => {
  const entry = registry.entries.find(({ role }) => roles.includes(role));

  if (entry) return { load: entry.load };
  if (registry.defaultLoad) return { load: registry.defaultLoad };

  return null;
};
